import React, { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import './CollegeContributeContainer.scss';
import { moduleActions } from '../../redux/modules';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from '../../redux/utils/analytics-helper';
import { getIsCorporateAccountType } from '../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';

export class CollegeContributeContainer extends Component {
  componentDidMount() {
    const {
      actions: { getTRPFunds, loadApplication, setAppLoading },
    } = this.props;
    setAppLoading();
    analyticsDataLayer();
    loadApplication(this.props.actions);
    getTRPFunds();
  }

  render() {
    const { children, ...otherProps } = this.props;
    return (
      <div className="college-contribute-container">
        {React.Children.map(children, (child) =>
          cloneElement(child, {
            ...otherProps,
            analyticsDataLayer,
            dispatchPageLoad,
          })
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { personalInformation } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    personalInformation,
    isCorporateAccountType: getIsCorporateAccountType(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...moduleActions }, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CollegeContributeContainer
);
